import React from "react";

const CTA = () => {
  return (
    <div className="cta">
      <a
        href="https://github.com/ktran123/r-sume/blob/main/Nam%20Tran%20Resume.pdf"
        target="_blank"
        rel="noreferrer"
        className="btn"
      >
        My Resume
      </a>
      <a href="#contact" className="btn btn-primary">
        Let's Talk
      </a>
    </div>
  );
};

export default CTA;
